import { createRouter } from '@tanstack/react-router';
import type { RouterContext } from './routes/__root';
import { routeTree } from './routeTree.gen';

// Create a new router instance
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    isAuthenticated: false,
    hasValidLicense: undefined,
    userRole: undefined,
  } satisfies RouterContext,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
